import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="footer">
      <h2>I am looking for a full time job.</h2>
      <button className="btn">
        <Link to="/contact" style={{ textDecoration: "none", color: "white" }}>
          Hire Me
        </Link>
      </button>
    </div>
  );
};

export default Footer;
